import module from 'module';

const templateUrl = require('./progressive-charge.template.html');
module.component('progressiveCharge',
  {
    templateUrl: templateUrl,
    bindings: {
      charge: '='
    }
  });